import React, { useEffect } from "react";
import Header from "./components/header";
import AOS from "aos";
import "aos/dist/aos.css";
import Navigation from "./components/navigation";
import Banner from "./components/banner";
import Portfolio from "./components/portfolio";
import Profil from "./components/profil";  // Impor komponen Profil
import Footer from "./components/footer";

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <div>
            <Header />
            <Navigation />
            <Banner />
            <Profil />  
            <Portfolio />
            <Footer />
        </div>
    );
}

export default App;
